import React from "react";
import "./DisclaimerBar.scss";
import { changeWeb3AuthChain } from "../../utils/services/web3auth";
import History from "../../utils/services/GlobalNavigation/navigationHistory";

interface DisclaimerBarProps {
  title: string;
  content: string;
  isConnectToPolygon?: boolean,
  isTopUpPlan?:boolean
}

const DisclaimerBar: React.FC<DisclaimerBarProps> = ({
  title,
  content,
  isConnectToPolygon = false,
  isTopUpPlan = false
}: DisclaimerBarProps) => {
  
  const changeChain = async () => {
    await changeWeb3AuthChain("polygon");
  };

  return (
    <div className={"DisclaimerBar"}>
      <div className="DisclaimerBar__container" style={isTopUpPlan ?{background:'#fff3cd' , color:'black'}:{}}>
        <div className="contentBox">
          <p className="contentBox__title">{title}</p>
          <p className="contentBox__subTitle" dangerouslySetInnerHTML={{ __html: content }}></p>
        </div>

        {isConnectToPolygon &&
          <div className="buttontBox">
            <button className="outlineBtn" onClick={changeChain}>
              Connect To Polygon
            </button>
          </div>
        }

        {
          isTopUpPlan &&     <div className="buttontBox">
          <button className="outlineBtn" onClick={()=>{
            History.navigate('/dashboard/topup')
          }}>
            Upgrade Plan
          </button>
        </div>
        }
      </div>
    </div>
  );
};

export default DisclaimerBar;
